import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Tab, TabList, TabValue, SelectTabData, SelectTabEvent, Title1 } from '@fluentui/react-components';

import { useSignInState } from './Components/signInState';
import { isBasecampWorkspaceAdminTier } from './constants/basecampWorkspaceRoleIds';

import GetCompanyDetails from './Components/GetCompanyDetails';
import FeatureConfiguration from './Components/FeatureConfiguration';

const AdminPage = () => {
    const { signInState } = useSignInState();

    const hasCompanyDetailsAccessFlag = isBasecampWorkspaceAdminTier(
        signInState.isWorkspaceSuperAdmin,
        signInState.workspaceRoleId,
    );

    const [selectedValue, setSelectedValue] = useState<TabValue>(
        hasCompanyDetailsAccessFlag ? 'CompanyDetails' : 'FeatureConfiguration',
    );

    const changePage = (_event: SelectTabEvent, data: SelectTabData) => {
        setSelectedValue(data.value);
    };

    const companyName = signInState.customerInfo.find(
        (customer) => customer.CustomerID === signInState.currentCustomerID,
    )?.CompanyName;

    return (
        <div style={{ margin: '20px' }}>
            <Title1>Account Admin - {companyName}</Title1>
            <TabList size="large" selectedValue={selectedValue} onTabSelect={changePage}>
                {hasCompanyDetailsAccessFlag && (
                    <Tab value="CompanyDetails">Company Details</Tab>
                )}
                <Tab value="FeatureConfiguration">Feature Configuration</Tab>
            </TabList>
            <br />
            {hasCompanyDetailsAccessFlag && selectedValue === 'CompanyDetails' && (
                <GetCompanyDetails CustomerID={signInState.currentCustomerID} />
            )}
            {selectedValue === 'FeatureConfiguration' && <FeatureConfiguration />}
        </div>
    );
};

export const AdminPageRoute = () => {
    const { signInState } = useSignInState();

    const hasPermission = isBasecampWorkspaceAdminTier(
        signInState.isWorkspaceSuperAdmin,
        signInState.workspaceRoleId,
    );

    if (!hasPermission) {
        return <Navigate to="/" />;
    }

    return <AdminPage />;
};

export default AdminPage;
